/**
 * «В других проектах» — запланированные сессии чтецов проекта в других проектах (GET /api/sessions/reader-planned).
 * Общий контракт сервера (SQL, курсор) и клиента (порядок при вставке сессии из сокета в загруженные порции).
 */

/** Порция по умолчанию — как у остальных постраничных списков нового интерфейса */
export const READER_PLANNED_PAGE_SIZE = 25;
export const READER_PLANNED_PAGE_MAX = 100;

/**
 * Запланированная — не внесённая, не отменённая, не монтаж и не заметка расписания.
 * Серверный SQL (readerPlannedSql) повторяет это условие: менять вместе.
 */
export function isReaderPlannedSession(s: {
  is_canceled?: boolean | null;
  is_recorded?: boolean | null;
  session_type?: string | null;
}): boolean {
  if (s.is_canceled || s.is_recorded) return false;
  const type = s.session_type ?? 'запись';
  return type !== 'монтаж' && type !== 'заметка';
}

/** Порядок списка: дата, начало, id (id — чтобы курсор был однозначным при одинаковом времени) */
export interface ReaderPlannedOrderKey {
  date: string;
  start: string;
  id: string;
}

export function compareReaderPlanned(a: ReaderPlannedOrderKey, b: ReaderPlannedOrderKey): number {
  if (a.date !== b.date) return a.date < b.date ? -1 : 1;
  if (a.start !== b.start) return a.start < b.start ? -1 : 1;
  if (a.id !== b.id) return a.id < b.id ? -1 : 1;
  return 0;
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const TIME_RE = /^\d{2}:\d{2}(:\d{2})?$/;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Курсор — последняя сессия порции: «дата|начало|id» */
export function encodeReaderPlannedCursor(key: ReaderPlannedOrderKey): string {
  return `${key.date}|${key.start}|${key.id}`;
}

export function parseReaderPlannedCursor(raw: string): ReaderPlannedOrderKey | null {
  const [date, start, id, ...rest] = raw.split('|');
  if (rest.length || !date || !start || !id) return null;
  if (!DATE_RE.test(date) || !TIME_RE.test(start) || !UUID_RE.test(id)) return null;
  return { date, start, id };
}

export interface ReaderPlannedPage<T> {
  items: T[];
  /** null — больше нет */
  nextCursor: string | null;
}

/** Сколько всего: сессия двух чтецов — один раз в total и у каждого в byReader */
export interface ReaderPlannedCounts {
  total: number;
  byReader: Record<string, number>;
}
